import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// eslint-disable-next-line no-restricted-imports
import { Form, Grid, Segment } from 'semantic-ui-react';

// Import components
import { routes } from '../../../../config/routes';
import PageHeader from '../../../Shared/PageHeader';
import PageTitle from '../../../Shared/PageTitle';

import { resetPaymentData } from '../../../../redux/actions/billingActions';
import { Steps } from '../Sidebar/Steps';
import { InvoiceContainer } from './Invoice';

class DetailsContainer extends React.Component {
  static propTypes = {
    paymentDetails: PropTypes.object,
  };

  state = {
    isInvoice: true,
    fireSubmit: false,
    isSubmitDetails: false,
  };

  componentDidMount() {
    if (this.props.paymentDetails) {
      this.setState({ ...this.props.paymentDetails });
    }
    if (this.props.location?.hash === routes.billing.detailsRecurringHash) {
      this.setState({
        isInvoice: false,
      });
    }
  }

  renderPageHeader = () => <PageHeader pageName={'Billing'} classes="billing" />;

  handleSubmit = () => {
    this.setState({ fireSubmit: true, isSubmitDetails: true }, () => {
      //reset submit state after passing down to child
      this.setState({ fireSubmit: false });
    });
  };
  getIsInvoice() {
    return this.props.isInvoice ?? this.state.isInvoice ?? this.props.paymentDetails?.isInvoice ?? true;
  }
  render() {
    const isInvoice = this.getIsInvoice();
    const { t } = this.props;

    return (
      <Segment basic>
        {this.renderPageHeader()}

        <Form onSubmit={this.handleSubmit} autoComplete="off">
          <Grid stackable reversed={'computer tablet'}>
            <Grid.Column computer={16} mobile={16} tablet={16}>
              <PageTitle
                data-testid="billing-details-title"
                title={
                  isInvoice
                    ? t('billing.invoiceCreation.details.oneTimeTitle')
                    : t('billing.invoiceCreation.details.recurringPlanTitle')
                }
              />
            </Grid.Column>

            <Grid.Row columns={2}>
              <Grid.Column computer={4} mobile={16} tablet={16}>
                <Steps isInvoice={isInvoice} />
              </Grid.Column>
              <Grid.Column computer={12} mobile={16} tablet={16}>
                {isInvoice ? (
                  <InvoiceContainer
                    fireSubmit={this.state.fireSubmit}
                    isSubmitDetails={this.state.isSubmitDetails}
                    firstInvoiceCreated
                  />
                ) : (
                  <></>
                )}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </Segment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    paymentDetails: state.paymentDetails,
    firstInvoiceCreated: state.organizations.currentOrganization?.setup?.firstInvoiceCreated,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      resetPaymentData,
    },
    dispatch
  );
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(DetailsContainer));
